import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = {
  key: 0,
  id: "main-content-port"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "w90 pad15 mt15" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "イメージを変更"),
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"10px"} }, "チャットやメールの内容として、お相手に表示されます。"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_7 = { class: "fl w65" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = { class: "w90 pad15 mt15" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10 blueBg" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "ユーザー名を変更"),
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"50px"} }),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_12 = { class: "fl w65" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "w90 pad15"
}
const _hoisted_16 = { class: "fl w30 pad10" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "会社名を変更", -1)
const _hoisted_18 = {
  key: 0,
  class: "fw600 alertBg mt20 fs12"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "fl w65" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = {
  key: 1,
  class: "w90 pad15"
}
const _hoisted_24 = { class: "fl w30 pad10" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "所属名（略称）を変更", -1)
const _hoisted_26 = {
  key: 0,
  class: "fw600 alertBg mt20 fs12"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = { class: "fl w65" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = {
  key: 2,
  class: "w90 pad15"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "独自メールアドレスを設定"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_33 = { class: "fl w65" }
const _hoisted_34 = {
  class: "fl ml10",
  style: {"line-height":"50px"}
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_37 = { class: "w90 pad15" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, [
    /*#__PURE__*/_createTextVNode(" 共有用メールアドレス を変更 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("(ご自身へのメール通知のCC） ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"50px"} }),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_39 = { class: "fl w65" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "fs11" }, "※カンマ区切りで複数メールアドレスの指定が可能です。", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_43 = { class: "w90 pad15" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, [
    /*#__PURE__*/_createTextVNode(" 返信先メールアドレス を変更 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("(確定通知などのメール通知から返信ボタンを押した際の返信先） ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"50px"} }),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_45 = { class: "fl w65" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("p", { class: "fs11" }, "※カンマ区切りで複数メールアドレスの指定が可能です。", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_49 = { class: "w90 pad15" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, " ")
], -1)
const _hoisted_51 = { class: "fl w65" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_53 = {
  key: 3,
  class: "w90"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "通話テスト")
], -1)
const _hoisted_55 = { class: "fl w65 centered pad20" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_UserSettingsHeader = _resolveComponent("UserSettingsHeader")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_TalkInterface = _resolveComponent("TalkInterface")!
  const _component_ImageBoardModal = _resolveComponent("ImageBoardModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu, { currentPage: `settings` }),
      (_ctx.rm.userInfo)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("form", {
              class: "formContent",
              style: {"text-align":"left"},
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("section", _hoisted_4, [
                _createVNode(_component_UserSettingsHeader, {
                  selectedTab: _ctx.selectedTab,
                  ref: "header"
                }, null, 8, ["selectedTab"]),
                _createElementVNode("section", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    (_ctx.rm.userInfo)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["userImage blackbrownBg ofh centered", `centered w100`]),
                          style: {"width":"100px","height":"100px","border-radius":"50%"}
                        }, [
                          _createVNode(_component_UserIcon, {
                            member: _ctx.rm.userInfo,
                            canEdit: false,
                            updateSelf: true,
                            width: 100,
                            class: "posAb",
                            onClickImage: _ctx.showImageBoardModal,
                            onUploaded: _ctx.uploadedUserImage
                          }, null, 8, ["member", "onClickImage", "onUploaded"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_8
                ]),
                _hoisted_9,
                _createElementVNode("section", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_TextfieldTag, {
                      placeholder: "waaq株式会社",
                      style: {"height":"50px","min-width":"280px","max-width":"100%"},
                      class: "fl fs14 roundForm w100",
                      value: _ctx.userName,
                      onInputValue: _ctx.inputUserName,
                      required: ""
                    }, null, 8, ["value", "onInputValue"])
                  ]),
                  _hoisted_13
                ]),
                _hoisted_14,
                (_ctx.rm.userInfo.is_company)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        (_ctx.rm.userInfo.user_group_role == 1)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_18, " 変更できるのは、管理者ユーザーのみです。変更したい場合は、管理者に依頼してください。 "))
                          : _createCommentVNode("", true),
                        _hoisted_19
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_TextfieldTag, {
                          placeholder: "waaq株式会社",
                          style: {"height":"50px","min-width":"280px","max-width":"100%"},
                          class: "fl fs14 roundForm w100",
                          value: _ctx.companyName,
                          onInputValue: _ctx.inputCompanyName,
                          isDisabled: _ctx.rm.userInfo.user_group_role == 1,
                          required: ""
                        }, null, 8, ["value", "onInputValue", "isDisabled"])
                      ]),
                      _hoisted_21
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_22,
                (_ctx.rm.userInfo.is_company)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        (_ctx.rm.userInfo.user_group_role == 1)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_26, " 変更できるのは、管理者ユーザーのみです。変更したい場合は、管理者に依頼してください。 "))
                          : _createCommentVNode("", true),
                        _hoisted_27
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_TextfieldTag, {
                          placeholder: "waaq または ワーク",
                          style: {"height":"50px","min-width":"280px","max-width":"100%"},
                          class: "fl fs14 roundForm w100",
                          value: _ctx.companyShortName,
                          onInputValue: _ctx.inputCompanyShortName,
                          maxlength: "4",
                          isDisabled: _ctx.rm.userInfo.user_group_role == 1,
                          required: ""
                        }, null, 8, ["value", "onInputValue", "isDisabled"])
                      ]),
                      _hoisted_29
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_30,
                (_ctx.rm.can_use_email_domain && _ctx.myEmailDomain)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_TextfieldTag, {
                          placeholder: "空の場合は、notificationが入ります。",
                          style: {"height":"50px","min-width":"280px","max-width":"280px"},
                          class: "fl fs14 roundForm w100",
                          value: _ctx.rm.email_name,
                          onInputValue: _ctx.inputEmailName,
                          required: ""
                        }, null, 8, ["value", "onInputValue"]),
                        _createElementVNode("div", _hoisted_34, "@" + _toDisplayString(_ctx.myEmailDomain), 1)
                      ]),
                      _hoisted_35
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_36,
                _createElementVNode("section", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_TextfieldTag, {
                      placeholder: "share@demo.waaq.jp",
                      style: {"height":"50px","min-width":"280px","max-width":"100%"},
                      class: "fl fs14 roundForm w100",
                      value: _ctx.ccEmails,
                      onInputValue: _ctx.inputCcEmails,
                      required: ""
                    }, null, 8, ["value", "onInputValue"]),
                    _hoisted_40
                  ]),
                  _hoisted_41
                ]),
                _hoisted_42,
                _createElementVNode("section", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_TextfieldTag, {
                      placeholder: _ctx.rm.userInfo ? _ctx.rm.userInfo.email : `reply@waaq.jp`,
                      style: {"height":"50px","min-width":"280px","max-width":"100%"},
                      class: "fl fs14 roundForm w100",
                      value: _ctx.replyEmails,
                      onInputValue: _ctx.inputReplyEmails,
                      required: ""
                    }, null, 8, ["placeholder", "value", "onInputValue"]),
                    _hoisted_46
                  ]),
                  _hoisted_47
                ]),
                _hoisted_48,
                _createElementVNode("section", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "pointer centered circle_button skyblueBg fs16",
                      style: {"width":"340px","padding":"8px 5px","max-width":"98%"},
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveName && _ctx.saveName(...args)))
                    }, " 保存 ")
                  ]),
                  _hoisted_52
                ]),
                false
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _hoisted_54,
                      _createElementVNode("div", _hoisted_55, [
                        _createVNode(_component_TalkInterface)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 32)
          ]))
        : _createCommentVNode("", true),
      _hoisted_56
    ]),
    _createVNode(_component_ImageBoardModal, {
      class: _normalizeClass(`posAb`),
      currentImageUrl: _ctx.currentImageUrl,
      title: `画像を選択`,
      onSelect: _ctx.selectFile
    }, null, 8, ["currentImageUrl", "onSelect"])
  ]))
}